//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"Component",1,0],[0,"DigitalOption",1,0],[0,"MeasureWithin",1,0],[0,"Name",1,0],[1,"SampleRate",0,"Expression",0],[0,"UseRelative",1,0],[0,"Variable",1,0]],[],[]];
SPLM.Motion.ControlInputPortBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ControlInputPortBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ControlInputPortBuilder.MeasuredComponent = Object.freeze({
    "Unused" : "Unused", "LinearMagnitude" : "LinearMagnitude", "X" : "X", "Y" : "Y", "Z" : "Z", "AngularMagnitude" : "AngularMagnitude", "Rx" : "Rx", "Ry" : "Ry", "Rz" : "Rz", "Radial" : "Radial", "Yaw" : "Yaw", "Pitch" : "Pitch", "Roll" : "Roll", "GravityExcludedLocalX" : "GravityExcludedLocalX", "GravityExcludedLocalY" : "GravityExcludedLocalY", "GravityExcludedLocalZ" : "GravityExcludedLocalZ", "TraveledDistanceLocalX" : "TraveledDistanceLocalX", "TraveledDistanceLocalY" : "TraveledDistanceLocalY", "TraveledDistanceLocalZ" : "TraveledDistanceLocalZ"});

SPLM.Motion.ControlInputPortBuilder.MeasuredVariable = Object.freeze({
    "Unused" : "Unused", "Displacement" : "Displacement", "Velocity" : "Velocity", "Acceleration" : "Acceleration", "GravityExcludedAcceleration" : "GravityExcludedAcceleration", "TraveledDistance" : "TraveledDistance"});

SPLM.Motion.ControlInputPortBuilder.UseRelativeType = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

SPLM.Motion.ControlInputPortBuilder.MeasureWithinOption = Object.freeze({
    "Absolute" : "Absolute", "Reference" : "Reference", "CSysOfInertia" : "CSysOfInertia"});

SPLM.Motion.ControlInputPortBuilder.DigitalType = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

export default SPLM;